/* eslint-disable */
export const getPrompt = (schema, basePlanPrompt = true) => {
	// console.log("schema------------->>123", Object.keys(schema));

	// const keys = Object.keys(schema).filter((key) => schema[key]?.is_present);
	let keys = Object.keys(schema).filter((key) => {
		if (key === "carrier_name") return true;
		if (key === "dependent_eligibility") return false;
		return schema[key]?.is_present;
	});
	// console.log("KEY", keys);
	const jsonKey = basePlanPrompt ? "standard_premium" : "rider_premium";

	const coverageFor = schema.coverage_for.options[0];
	if (!coverageFor) {
		throw new Error("Coverage for option is missing");
	}

	if (!schema.pay_frequency.options[0]) {
		throw new Error("Pay frequency option is missing");
	}

	const payFrequencyObject = {};

	for (const payFreq of schema.pay_frequency.options) {
		payFrequencyObject[payFreq] = 0;
	}

	if (schema.coverage_volume.is_present && !schema.coverage_volume.options[0]) {
		throw new Error("Coverage volume options are missing");
	}

	if (schema.benefit_amount.is_present && !schema.benefit_amount.options[0]) {
		throw new Error("Benefit amount options are missing");
	}

	let ageCriteriaOption;
	if (schema.age_criteria.is_present && schema.age_criteria.use_specific_ages) {
		ageCriteriaOption = schema.age_criteria.specific_age_list[0];

		if (!ageCriteriaOption) {
			throw new Error("Age criteria specific age list is missing");
		}
	}

	if (schema.age_criteria.is_present && schema.age_criteria.use_age_bands) {
		ageCriteriaOption = schema.age_criteria.age_band_ranges[0];

		if (!ageCriteriaOption) {
			throw new Error("Age criteria age band list is missing");
		}
	}

	if (!basePlanPrompt) {
		keys.unshift("carrier_name");
	}
	if (keys.includes("rider")) {
		keys = keys.filter((key) => key !== "rider");
	}

	const result = keys.join("+");
	// console.log(
	// 	"standardPremium===============================================================----------->",
	// 	payFrequencyObject,
	// 	result,
	// 	basePlanPrompt
	// );
	// return ""

	let jsonPrompt;
	switch (result.toLocaleLowerCase()) {
		case "carrier_name+coverage_for+pay_frequency":
			jsonPrompt = `
                ${coverageFor}:${JSON.stringify(payFrequencyObject)}`;

			break;
		case "carrier_name+coverage_for+coverage_volume+pay_frequency":
			jsonPrompt = `
                ${schema.coverage_volume.options[0]}:{ ${coverageFor}:${JSON.stringify(payFrequencyObject)}`;
			break;

		case "carrier_name+coverage_for+pay_frequency+benefit_amount":
			jsonPrompt = `
                ${coverageFor}:{${schema.benefit_amount.options[0]}:${JSON.stringify(payFrequencyObject)}
                }`;

			break;

		case "carrier_name+coverage_for+coverage_volume+pay_frequency+benefit_amount":
			jsonPrompt = `
                ${schema.coverage_volume.options[0]}:{
                    ${coverageFor}:{${schema.benefit_amount.options[0]}:${JSON.stringify(payFrequencyObject)}
                }}`;

			break;

		case "carrier_name+coverage_for+pay_frequency+age_criteria":
			jsonPrompt = `
                ${coverageFor}:{${ageCriteriaOption}:${JSON.stringify(payFrequencyObject)}
                }`;
			break;
		case "carrier_name+coverage_for+pay_frequency+benefit_amount+age_criteria":
			jsonPrompt = `
                ${coverageFor}:{${ageCriteriaOption}:{${schema.benefit_amount.options[0]}:${JSON.stringify(
				payFrequencyObject
			)}}
                }`;
			break;
		case "carrier_name+coverage_for+coverage_volume+pay_frequency+age_criteria":
			jsonPrompt = `
                ${schema.coverage_volume.options[0]}:{
                    ${coverageFor}:{${ageCriteriaOption}:${JSON.stringify(payFrequencyObject)}
                }}`;

			break;
		case "carrier_name+coverage_for+coverage_volume+pay_frequency+benefit_amount+age_criteria":
			jsonPrompt = `
                ${schema.coverage_volume.options[0]}:{
                    ${ageCriteriaOption}:{${coverageFor}:{${schema.benefit_amount.options[0]}:${JSON.stringify(
				payFrequencyObject
			)}}
                }}`;

			break;
		default:
			jsonPrompt = "";
		// code block
	}

	let finalPrompt = `${jsonKey}:{${jsonPrompt}}`;
	// console.log("finalPrompt222222222", finalPrompt, jsonPrompt);

	if (schema.is_premium_depends_on_smoke) {
		finalPrompt = "";
		finalPrompt = `"${jsonKey}":{"smoker":{${jsonPrompt}},"non_smoker":{${jsonPrompt}}}`;
	}

	return finalPrompt;
};
